import { Component, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
  selector: 'app-demande-attestation',
  templateUrl: './demande-attestation.component.html',
  styleUrls: ['./demande-attestation.component.scss']
})
export class DemandeAttestationComponent implements OnInit {
  configuration = this.configurationService.get().demandeAttestation;
  constructor(private configurationService: ConfigurationService) {
  }

  ngOnInit(): void {
    console.log('Host configuration:', this.configuration);

  }
}
